const fields = [
  {
    key: 'licensePlate',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'ritageName',
    label: 'report.fields.ritageName',
    header: 'ritageName',
    filter: false,
    width: 30,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'departureDate',
    label: 'report.fields.departureDate',
    header: 'departureDate',
    filter: false,
    width: 30,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'depart',
    label: 'report.fields.depart',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'routeDepart',
        label: 'report.fields.route',
        header: 'routeDepart',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 1,
        isLocked: true,
      },
      {
        key: 'departureLocation',
        label: 'report.fields.departureLocation',
        header: 'departureLocation',
        headerColspan: 1,
        childOfIndex: 0,
        isTopHead: 0,
        isLocked: true,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'return',
    label: 'report.fields.return',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'routeReturn',
        label: 'report.fields.route',
        header: 'routeReturn',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 1,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'returnLocation',
        label: 'report.fields.returnLocation',
        header: 'returnLocation',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 1,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'ritage',
    label: 'report.fields.ritage',
    header: 'ritage',
    filter: false,
    width: 30,
    headerRowspan: 2,
    isLocked: true,
  },
  {
    key: 'totalMileage',
    label: 'KM',
    header: 'totalMileage',
    filter: false,
    width: 10,
    headerRowspan: 2,
    isLocked: true,
  },
]
export default fields
